import React from "react";

const HeroSection = () => {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex flex-col"
      style={{ background: "linear-gradient(180deg,#ECE7F8 0%,#F4EFFB 45%,#FCFAFF 100%)" }}
    >
      {/* soft aura */}
      <div
        className="blob1 absolute top-24 right-[8%] w-80 h-80 rounded-full blur-3xl opacity-50"
        style={{ background: "radial-gradient(circle,#DCD6F5,transparent 65%)" }}
      />
      <div
        className="blob2 absolute bottom-24 left-[6%] w-72 h-72 rounded-full blur-3xl opacity-40"
        style={{ background: "radial-gradient(circle,#F7E4EC,transparent 65%)" }}
      />

      {/* top 50% (includes the fixed header) */}
      <div aria-hidden="true" className="grow-[50]" />

      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <div>
          <h1 className="font-display font-normal tracking-tight text-4xl sm:text-6xl lg:text-7xl leading-[1.08]">
            <span className="block lg:whitespace-nowrap rise" style={{ animationDelay: ".32s" }}>
              We don't chase markets.
            </span>
            <span className="block lg:whitespace-nowrap rise" style={{ animationDelay: ".5s" }}>
              We create{" "}
              <span className="relative italic font-normal text-rose">
                new ones.
                <svg
                  className="absolute left-0 -bottom-2 w-full"
                  height="16"
                  viewBox="0 0 300 16"
                  preserveAspectRatio="none"
                  fill="none"
                >
                  <path
                    d="M3 10 C 55 3, 110 15, 165 8 S 258 4, 297 11"
                    stroke="#D8073C"
                    strokeWidth="3"
                    strokeLinecap="round"
                    className="draw"
                  />
                </svg>
              </span>
            </span>
          </h1>
          <p
            className="mt-8 text-lg sm:text-xl text-ink/60 max-w-xl mx-auto leading-relaxed font-normal rise"
            style={{ animationDelay: ".72s" }}
          >
            <span className="block">We take on hard problems, solve them.</span>
            <span className="block">Guided by data and intuition.</span>
          </p>
          <div className="mt-10 rise" style={{ animationDelay: ".92s" }}>
            <a href="#about" className="hero-cta soft-1">
              <span className="hero-cta-lbl">See how we work</span>
              <span className="hero-cta-disc">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* bottom 50% */}
      <div aria-hidden="true" className="grow-[50]" />
    </section>
  );
};

export default HeroSection;